import React from 'react';
import { Target } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ScrollArea } from '@/components/ui/scroll-area';

import InfoIcon from './InfoIcon';
import ScopeDot from './ScopeDot';
import { formatEuro } from '../../utils/money';

const OpportunitiesInline = ({ opportunities, navigate }) => {
  if (!opportunities || opportunities.length === 0) {
    return (
      <Card data-testid="opportunities-inline-card">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium flex items-center gap-2">
            <Target className="w-4 h-4" />
            Oportunidades que Requieren Atención
            <InfoIcon text="Oportunidades que requieren atención por plazo, valor o inactividad." testid="info-opportunities-inline" ariaLabel="Información sobre Oportunidades" />
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-xs text-muted-foreground">Todas al día.</p>
        </CardContent>
      </Card>
    );
  }
  return (
    <Card data-testid="opportunities-inline-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium flex items-center justify-between">
          <span className="flex items-center gap-2">
            <Target className="w-4 h-4" />
            Oportunidades
            <InfoIcon text="Oportunidades que requieren atención por plazo, valor o inactividad." testid="info-opportunities-inline" ariaLabel="Información sobre Oportunidades" />
          </span>
          <Badge variant="secondary" className="text-xs">{opportunities.length}</Badge>
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <ScrollArea className="h-[140px]">
          <div className="space-y-0.5">
            {opportunities.map((o) => {
              // Feb 2026 spec: show offered_amount + TDS, never estimated_value.
              // If Pública and no offered: show "(presupuesto base)" in grey.
              // If Privada/TYPSA with no offered: "Sin importe ofertado".
              const hasOffered = o.offered_amount !== null && o.offered_amount !== undefined && o.offered_amount !== 0;
              const isPublica = o.scope === 'publica';
              return (
                <button
                  key={o.id}
                  type="button"
                  onClick={() => navigate(`/pipeline/${o.id}`)}
                  className="w-full flex items-center gap-2 px-2 py-1 rounded hover:bg-muted/60 text-left"
                  data-testid={`opp-inline-${o.id}`}
                >
                  <ScopeDot scope={o.scope} />
                  <span className="flex-1 truncate text-xs font-medium">{o.title}</span>
                  {hasOffered ? (
                    <span className="text-[10px] whitespace-nowrap">
                      <span className="text-green-700 font-semibold">{formatEuro(o.offered_amount)}</span>
                      {o.tds_amount ? (
                        <span className="text-muted-foreground"> · TDS {formatEuro(o.tds_amount)}</span>
                      ) : null}
                    </span>
                  ) : isPublica && o.estimated_value ? (
                    <span className="text-[10px] text-muted-foreground whitespace-nowrap italic">
                      {formatEuro(o.estimated_value)} (presupuesto base)
                    </span>
                  ) : (
                    <span className="text-[10px] text-muted-foreground whitespace-nowrap italic">
                      Sin importe ofertado
                    </span>
                  )}
                  <Badge variant="outline" className="text-[9px] flex-shrink-0">{o.stage}</Badge>
                </button>
              );
            })}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
};

export default OpportunitiesInline;
